module.exports = __webpack_public_path__ + "img/619.Coffee_cooling_malfunction.7a4b0feb.svg";